import { api, RequiredGraphqlState, WithGraphqlReducer } from '@main/graphql/shared-api';
import { combineReducers, configureStore, createReducer, Reducer } from '@reduxjs/toolkit';

import { fileListenerMiddleware } from '../features/file/middleware';
import { userListenerMiddleware } from '../features/user/middleware';
import { userReducer, userSignedOut } from '../features/user/slice';
import { nhost } from '../utils/nhost-client';

const appReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  me: userReducer,
  gql: createReducer<RequiredGraphqlState>(
    { nhostClient: nhost, defaultRole: 'admin' },
    () => null,
  ),
} satisfies WithGraphqlReducer);

const rootReducer: Reducer<ReturnType<typeof appReducer>> = (state, action) => {
  if (userSignedOut.match(action)) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: { ignoredPaths: ['gql'] },
    }).concat([
      api.middleware,
      userListenerMiddleware.middleware,
      fileListenerMiddleware.middleware,
    ]),
  devTools: import.meta.env.DEV,
});

export type BackofficeRootState = ReturnType<typeof store.getState>;
export type BackofficeAppDispatch = typeof store.dispatch;
